<template>
  <v-btn
    :disabled="disabled"
    :depresed="depresed"
    :fab="fab"
    :large="large"
    :outlined="outlined"
    @click="$emit(action)"
    :block="isBlock"
    :class="disabled ? 'mr-2' : outlined ? '' : color + ' mr-2'"
  >
    <v-icon :class="fab ? '' : 'mr-2'">{{ icon }}</v-icon>
    {{ fab ? "" : text }}
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: "mdi-file",
    },
    text: {
      type: String,
      default: "Simpan",
    },
    color: {
      type: String,
      default: "primary",
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    depresed: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: "save",
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
